import Job from 'models/Job';
import JobCity from 'models/JobCity';

import { Props as ButtonProps } from 'components/layout/Button';

import Component from './component';

export interface Props {
    job: Job;
    jobCity: JobCity;
    buttonProps: {
        save: ButtonProps;
        road: ButtonProps;
    }
    onSaveJobFavourites: (id: string, jobCityId:string) => any;
    userEmail?: string;
}

Component.defaultProps = {};

export default Component;